.popover {
  position: fixed;
  z-index: var(--cl-z-popover);
  color: var(--cl-text);
  font-size: var(--cl-fs-base);
}

.menu {
  background: var(--cl-dropdown-bg);
  border-radius: var(--cl-radius);
  box-shadow: var(--cl-menu-shadow);
}

.card {
  background: var(--cl-dropdown-bg);
  border-radius: var(--cl-radius);
  box-shadow: var(--cl-popover-shadow);
}

.bare {
  background: transparent;
}
